<template>
  <div class="learning-center">
    <navigation :scene="scene" @change="toggleScene" />
    <match-notice />
    <div class="learning-center-content">
      <transition-group name="fade" mode="out-in">
        <index
          key="index"
          v-if="scene === 'index'"
          @change="toggleScene" />
        <select-course
          key="selectCourse"
          v-show="scene === 'selectCourse'"
          :is-show="scene === 'selectCourse'"
          @change="toggleScene" />
        <review-course
          key="reviewCourse"
          v-show="scene === 'reviewCourse'"
          :show="scene === 'reviewCourse'"
          @close="back"
          @change="toggleScene"
        />
        <stage-test
          key="stageTest"
          v-show="scene === 'stageTest'"
          @change="toggleScene" />
        <personal
          key="personal"
          v-if="scene === 'personal'"
          @change="toggleScene" />
        <report-module
          key="report"
          v-if="scene === 'report'"
          @change="toggleScene" />
        <level-dialog
          key="levelDialog"
          v-show="scene === 'levelDialog'"
          :show="scene === 'levelDialog'"
          @change="toggleScene"
        />
        <unit-module
          key="unitMoudle"
          v-show="scene === 'unitModule'"
          :show="scene === 'unitModule'"
          :course="currentCourse"
          @close="back"
          @change="toggleScene" />
        <word-unit-module
            key="wordUnit"
            v-if="scene === 'wordUnit'"
            @close="back"
            @change="toggleScene"
          :course="currentCourse" />
        <word-exam
            key="wordExam"
            v-if="scene === 'wordExam'"
            @close="back"
            @change="toggleScene"
            :unit="currentUnit"
          :course="currentCourse" />
        <quizzes-dialog
            key="quizzesDialog"
            v-if="scene === 'quizzesDialog'"
            ref="quizzesDialog"
            @close="back"
            @change="toggleScene"
            :params="params"
            :type="type"
            :module="currentModule"
            :unit="currentUnit"
          :course="currentCourse" />
        <wrong-book-dialog
            key="wrongBookDialog"
            v-show="scene === 'wrongBookDialog'"
            :show="scene === 'wrongBookDialog'"
            @close="back"
            @change="toggleScene" />
        <word-exam-dialog
          key="wordExamDialog"
          v-if="scene === 'wordExamDialog'" />
        <course-report
          v-if="scene === 'courseReport'"
          key="courseReport"
          @close="back"
          @change="toggleScene"
        />
        <error-prone-set
          v-if="scene === 'ErrorProneSet'"
          key="ErrorProneSet"
          @change="toggleScene"
          @close="back"
        />
        <ds-unit-module
          key="dsUnitModule"
          @close="back"
          @change="toggleScene"
          :course="currentCourse"
          :show="scene === 'dsUnit'"
          v-show="scene === 'dsUnit'" />
        <fallibleSet
          v-if="scene === 'fallibleSet'"
          @change="toggleScene"
          key="fallibleSet"
        />
      </transition-group>
    </div>
  </div>
</template>

<script>
import utils from '@/services/utils';
import MatchNotice from '@/components/match/Notice.vue';
import Navigation from './components/Navigation.vue';
import Index from './components/Index.vue';
import SelectCourse from './components/SelectCourse.vue';
import Personal from './components/Personal.vue';
import ReportModule from './components/ReportModule.vue';
import UnitModule from './components/UnitModule.vue';
import WordUnitModule from './components/word/WordUnitModule.vue';
import WordExam from './components/word/WordExam.vue';
import WordExamDialog from './components/word/WordExamDialog.vue';
import QuizzesDialog from './components/QuizzesDialog.vue';
import WrongBookDialog from './components/WrongBookDialog.vue';
import DsUnitModule from './components/ds/DsUnitModule.vue';
import accountApi from '@/api/graphql/account';
import StageTest from './components/stageTest/StageTest.vue';
import CourseReport from './components/report/CourseReport.vue';
import ErrorProneSet from './components/report/ErrorProneSet.vue';
import ReviewCourse from './components/ReviewCourse.vue';
import LevelDialog from './components/level/LevelDialog.vue';
import FallibleSet from './components/FallibleSet.vue';

export default {
  components: {
    Navigation,
    Index,
    SelectCourse,
    UnitModule,
    WordUnitModule,
    WordExam,
    QuizzesDialog,
    WrongBookDialog,
    WordExamDialog,
    MatchNotice,
    DsUnitModule,
    StageTest,
    Personal,
    ReportModule,
    CourseReport,
    ErrorProneSet,
    ReviewCourse,
    LevelDialog,
    FallibleSet,
  },
  data() {
    return {
      annalsDialogVisible: false,
      scene: 'index',
      currentCourse: {},
      currentUnit: {},
      currentModule: {},
      type: '',
      params: {},
      history: [],
    };
  },
  computed: {
    qrCodeUrl() {
      const account = utils.storage('account');
      let userId = null;

      if (account) {
        userId = account.id;
      }

      const url = `activities/2020/annals?user_id=${userId}`;

      return utils.getPassionTeacherUrl(url);
    },
    isShowAnnualButton() {
      const account = utils.storage('account');
      const { isShowAnnualButton } = account || { isShowAnnualButton: false };

      return isShowAnnualButton;
    },
  },
  mounted() {
    // this.smartPushAnnals();
  },
  methods: {
    logout() {
      accountApi
        .logout()
        .then(({ logout }) => {
          const { url } = logout;
          utils.logout(url);
        });
    },
    smartPushAnnals() {
      /* eslint-disable */
      const account = utils.storage('account');

      if (account && account.isPushAnnual) {
        const annalsPushDate = new Date(utils.storage(`${account.id}_anals_push_date`));
        const nowDate = new Date();

        if (annalsPushDate) {

          if ((nowDate - annalsPushDate) >= 60 * 60 * 24 * 1000) {
            this.annalsDialogVisible = true;
            utils.storage(`${account.id}_anals_push_date`, new Date());
          }

        } else {
          utils.storage(`${account.id}_anals_push_date`, new Date());
          this.annalsDialogVisible = true;
        }
      }
    },
    toggleScene({ scene, params = {} }, historyType) {
      this.scene = scene;

      if (params.course) {
        this.currentCourse = params.course;
      }
      if (params.unit) {
        this.currentUnit = params.unit;
      }
      if (params.module) {
        this.currentModule = params.module;
      }
      if (params.type) {
        this.type = params.type;
      }
      this.params = params;

      if (historyType !== 'back') {
        this.handleHistory(scene, params);
      }
    },
    handleHistory(scene, params) {
      this.history.push({
        scene,
        params,
      });
    },
    back() {
      this.history.pop();
      if (this.history.length) {
        const currentScene = this.history[this.history.length - 1];
        this.toggleScene(currentScene, 'back');
      } else {
        this.toggleScene({ scene: 'index' }, 'back');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  @import '@/styles/common/breadcrumb.scss';

  .learning-center {
    display: flex;
    height: 100%;
    min-height: 700px;
    .learning-center-content {
      flex-grow: 1;
      height: 100%;
      min-width: 1300px;
      overflow-x: auto;
      background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/17227050e20c32d3406f24454036de99.png')
        no-repeat center center / cover;
      .main {
        display: flex;
        width: 100%;
        height: 100%;
        .main-left {
          display: flex;
          justify-content: center;
          overflow: hidden;
          width: 71%;
          height: 100%;
          background-image: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/d713a5c33022ee9058eb2de102295bb9.png');
          background-size: cover;
          .card-wrapper {
            display: inline-block;
            .bottom {
              display: flex;
              justify-content: space-between;
              margin-top: 100px;
            }
          }
        }
        .main-right {
          width: 29%;
          height: 100%;
        }
      }
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: all .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>
